<template>
	<main>
		<div class="container closed c_inner">
			<div class="closed_img">
				<img src="@/assets/img/common/exclamation.png" alt="구독 안내 아이콘" loading="lazy" />
			</div>
			<div class="closed_txt">
				<p>현재는 신규 가입을 받지 않고 있습니다.</p>
			</div>
			<button class="closed_btn" @click="router.push('/')">홈 화면 바로가기</button>
		</div>
	</main>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 8.8rem;
	max-width: 68rem;
	padding-top: 7.2rem;
	margin: 0 auto;
	margin-top: var(--header-height);
	margin-bottom: 8.8rem;
	@media screen and (max-width: 1280px) {
		gap: 8rem;
		padding-top: 4rem;
		padding-bottom: 4rem;
	}
}

.container.closed {
	justify-content: center;
	align-items: center;
	gap: 0;
	height: calc(100dvh - var(--header-height) - var(--footer-height) - 5px);
	padding-top: 0;
	margin-top: var(--header-height);
	margin-bottom: 0;
	@media screen and (max-width: 1280px) {
		height: calc(100dvh - var(--header-height) - var(--bottomMenu-height) - 5px);
	}
	.closed_img {
		width: 12rem;
		height: 12rem;
		margin-bottom: 2.4rem;
	}
	.closed_txt {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		text-align: center;
		margin-bottom: 3.2rem;
		p {
			font-size: var(--font-s-x-large);
			font-weight: var(--font-w-bold);
			line-height: 2.387rem;
		}
	}
	.closed_btn {
		width: 24rem;
		padding: 1.35rem 1.6rem;
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-medium);
		background-color: var(--color-primary);
		border-radius: 0.6rem;
	}
}
</style>
